import { get, post } from '@/api'

/**
 * 分页查询预约单列表
 * @param {Object} data ReservationQueryDTO
 * @param {number} [data.pageNum]
 * @param {number} [data.pageSize]
 * @param {string} [data.orderBy]
 * @param {string} [data.orderDir]
 * @param {string} [data.reservationNo] 预约单号
 * @param {string} [data.brand] 意向品牌
 * @param {string} [data.carModel] 意向车型
 * @param {string} [data.city] 城市
 * @param {string} [data.reservationTestDriveTimeStart] 预约试驾时间-开始
 * @param {string} [data.reservationTestDriveTimeEnd] 预约试驾时间-结束
 * @param {string} [data.phone] 手机号
 */
export function getReservationPage(data) {
  return post('/reservation/page', data)
}

/**
 * 查询预约单详情
 * @param {number|string} id 预约单ID
 */
export function getReservationDetail(id) {
  return get(`/reservation/detail/${id}`)
}

/**
 * 更新预约单
 * @param {Object} data ReservationUpdateDTO
 * @param {number} data.id 数据主键ID（必填）
 * @param {string} [data.carModel] 预约车型
 * @param {string} [data.reservationTestDriveTime] 预约试驾时间
 * @param {string} [data.city] 预约城市
 * @param {string} [data.phone] 联系电话
 * @param {string} [data.address] 上门地址
 * @param {string} [data.remark] 备注
 */
export function updateReservation(data) {
  return post('/reservation/update', data)
}
